import type { DpopKeyPair } from './key';
import { signWithDpopKey, toBase64Url } from './key';

// three base64url segments joined by dots, the last signing the first two.
// null when it cannot be built, so the request just goes out unsigned.
export async function getDpopHeaderValue(
  keyPair: DpopKeyPair,
  method: string,
  url: URL,
): Promise<string | null> {
  try {
    const protectedHeader = toBase64Url(
      JSON.stringify({ typ: 'dpop+jwt', alg: 'ES256', jwk: keyPair.publicKey }),
    );
    const payload = toBase64Url(
      JSON.stringify({
        htm: method.toUpperCase(),
        // the server matches origin + path exactly: query and fragment go, slash stays
        htu: `${url.origin}${url.pathname}`,
        // seconds — milliseconds read as a far-future date and get rejected
        iat: Math.floor(Date.now() / 1000),
        jti: crypto.randomUUID(),
      }),
    );
    const signingInput = `${protectedHeader}.${payload}`;
    return `${signingInput}.${await signWithDpopKey(keyPair.privateKey, signingInput)}`;
  } catch (error) {
    // a key that can no longer sign, or a broken JSON/base64 step
    console.warn('Failed to sign this request:', error);
    return null;
  }
}
